import axios from 'axios';
import qs from 'qs'
import {
    Message,
} from 'element-ui'
import router from '@/router';
import storage from '@/fetch/storage'
import i18n from "../i18n";
import {getTenantLoginPath} from '@/utils/tenantLogin'

// 创建实例
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    timeout: 1000000,
    headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'}
})

// 请求拦截器
service.interceptors.request.use(config => {
    const token = storage.get('token')
    const lang = localStorage.getItem('language') || 'zh_CN'
    const infoMsg = storage.get('infoMsg')

    if (token) config.headers.Authorization = token
    config.headers.lang = lang === 'zh_CN' ? 'zh_CN' : 'en_US'
    if (infoMsg) config.headers['TENANT-ID'] = infoMsg.tenantId

    return config
}, error => Promise.reject(error))


// 响应拦截器
service.interceptors.response.use(
    response => {
        const {status, data} = response
        const {code, msg} = data
        if (status === 200) {
            if(!code) return data
            if (code === 200) {
                return data
            } else if (code === 401) {
                toLogin()
            } else if (code === 463) {
                if (!router.currentRoute.path.includes('/login')) {
                    toLogin(msg || '系统授权已失效，请重新登录')
                }
                return Promise.reject(response)
            } else if(code === 500){
                Message({
                    message: msg,
                    type: "error"
                });
                if(msg === '租户已到期，或已被禁用'){
                    toLogin()
                }else {
                    return Promise.reject(response)
                }
            } else {
                Message({
                    message: msg,
                    type: "warning"
                });
                return Promise.reject(response)
            }
        } else {
            Message({
                message: i18n.t('serverIsBusy'),
                type: "err"
            });
            return Promise.reject(response)
        }
    },
    error => {
        return Promise.reject(error)
    }
)

function toLogin(message) {
    storage.remove("token");
    Message({
        message: message || i18n.t('LoginFailed'),
        type: "warning"
    });
    router.replace({
        path: getTenantLoginPath(router.currentRoute)
    })
}

function buildURL(url, needToken) {
    if (!needToken) {
        return url = url + (url.indexOf('?') >= 0 ? "&" : "?");
    }
    let token = storage.get('token');
    if (!token) {
        storage.remove("token");
        router.replace(getTenantLoginPath(router.currentRoute))
    }
    return url
}

export function request(method, url, params = {}, isJson = false, options = {}) {
    const isFormData = params instanceof FormData;

    const config = {
        method,
        url,
        headers: {
            // 如果是 FormData，就不要设置 Content-Type，让浏览器自动处理
            ...(isFormData
                ? {}
                : { 'Content-Type': isJson ? 'application/json' : 'application/x-www-form-urlencoded' })
        },
        ...options
    };

    if (method === 'GET') {
        config.params = params;
        config.paramsSerializer = p => qs.stringify(p, { arrayFormat: 'repeat' });
    } else {
        config.data = isJson
            ? params
            : (isFormData ? params : qs.stringify(params));
    }

    return service(config);
}


// 快捷方法
export const fetchGet = (url, params,isJson,options = {}) => request('GET', url, params,isJson,options)
export const fetchPost = (url, params, isJson,options={}) => request('POST', url, params, isJson,options)
export const fetchPut = (url, params, isJson) => request('PUT', url, params, isJson)
export const fetchDelete = (url, params) => request('DELETE', url, params)

function downloadFile(url, filename, params = '', type = 'xlsx') {
    url = buildURL(url, true);
    return new Promise((resolve) => {
        axios
            .get(url, {
                params: params, paramsSerializer: function (params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                },
                responseType: "blob" // 指定响应类型为 blob
            })
            .then((response) => {
                const blob = new Blob([response.data]);
                const downloadUrl = URL.createObjectURL(blob);
                const downloadLink = document.createElement("a");
                downloadLink.href = downloadUrl;
                downloadLink.download = filename + '.' + type;
                downloadLink.click();
                URL.revokeObjectURL(downloadUrl);
                resolve(response.data)
            })
            .catch((error) => {
                console.error("Error downloading file:", error);
            });
    })

}

function toLegacyUserSaveParams(params = {}) {
    const next = {...params}
    if (Array.isArray(next.postIds)) {
        next.postIds = next.postIds.join(',')
    }
    return next
}

export default {
    getPageList(data) {
        if (!data) return []
        if (Array.isArray(data)) return data
        if (Array.isArray(data.data)) return data.data
        if (Array.isArray(data.list)) return data.list
        if (Array.isArray(data.records)) return data.records
        if (Array.isArray(data.content)) return data.content
        return []
    },
    getPageTotal(data) {
        if (!data) return 0
        return data.total_records || data.total || data.totalElements || 0
    },
    getPageCount(data, pageSize) {
        if (!data) return 0
        if (data.total_pages || data.total_pages === 0) return data.total_pages
        const total = this.getPageTotal(data)
        return total && pageSize ? Math.ceil(total / pageSize) : 0
    },
    page(requestType, url, params, needToken) {
        if (requestType == 'GET') {
            return fetchGet(url, params, needToken);
        }
        if (requestType == 'POST') {
            return fetchPost(url, params, needToken);
        }
    },
    // register
    register(params) { //邮箱
        return fetchPost('/member/web/register', params, false)
    },
    mobileRegister(params) {//手机
        return fetchPost('/member/web/register/mobile', params, false)
    },
    // send email
    sendEmail(params) {
        return fetchGet('/member/web/register/send/email', params, false)
    },
    sendMobile(params) {
        return fetchPost('/member/web/register/send/sms', params, false)
    },
    // login
    login(params) {
        return fetchPost('/member/web/login', params, false);
    },
    licenseRequestFile(params) {
        return fetchGet('/system/license/request-file', params, false);
    },
    activateLicense(params) {
        return fetchPost('/system/license/activate', params, false);
    },
    licenseStatus(params) {
        return fetchGet('/system/license/status', params);
    },
    // update user info
    updateUserInfo(params) {
        return fetchPost('/member/web/user/update/info', params);
    },
    // Reset Password
    resetPassword(params) {
        return fetchPost('/member/web/user/update/password', params, false);
    },
    // change account
    changeAccount(params) {
        return fetchGet('/member/web/user/switch/account', params);
    },
    dashboardListUnit(params) {
        return fetchGet('/device/web/dashboard/unit/page', params, true);
    },
    dashboardListUnitPart(params) {
        return fetchGet('/device/web/dashboard/unit/part/page', params);
    },
    // dashboard list
    dashboardList(params) {
        return fetchGet('/device/web/dashboard/noPageList', params);
    },
    // alarm list
    alarmList(params) {
        return fetchGet('/alarm/web/alarm/noPageList', params);
    },
    // ack alarm
    ackAlarm(params) {
        return fetchPost('/alarm/web/alarm/accept', params);
    },
    // download device
    downloadDevice(params) {
        return fetchGet('/device/web/device/getData', params);
    },
    // device detail
    deviceDetail(params) {
        return fetchGet('/device/web/device/detail/info', params);
    },
    // device channel
    deviceChannel(params) {
        return fetchGet('/device/web/device/detail/channel', params);
    },
    // device log
    deviceLog(params) {
        return fetchGet('/device/web/device/detail/log', params);
    },
    // device chart
    getLogChart(params) {
        return fetchGet('/device/web/device/v2/detail/log/data', params)
    },
    // channel value
    channelValue(params) {
        return fetchGet('/device/web/channel/unit', params)
    },
    // device channel list
    deviceChannelList(params) {
        return fetchGet('/device/web/device/channel/list', params);
    },
    addDashboard(params) {
        return fetchPost('/device/web/dashboard/edit', params)
    },
    // delete dashboard
    deletDashboard(params) {
        return fetchGet('/device/web/dashboard/delete', params)
    },
    // dashboard info
    dashboardInfo(params) {
        return fetchGet('/device/web/dashboard/info', params);
    },
    // update dashboard status
    updateStatus(params) {
        return fetchGet('/device/web/dashboard/update/status', params)
    },

    // ALARM
    // user device
    getDevice(params) {
        return fetchGet('/device/web/device/getDevice', params)
    },
    // device channel
    getChannel(params) {
        return fetchGet('/device/web/device/getChannel', params)
    },
    // add alarm
    addAlarm(params) {
        return fetchPost('/alarm/web/alarm/addAlarm', params);
    },
    // update alarm
    updateAlarm(params) {
        return fetchPost('/alarm/web/alarm/updateAlarm', params);
    },
    // delete alarm
    deleteAlarm(params) {
        return fetchPost('/alarm/web/alarm/deleteAlarm', params);
    },
    // USERS
    // add user
    addUser(params) {
        return fetchPost('/member/web/user/add/user', toLegacyUserSaveParams(params));
    },
    // update user
    updateUser(params) {
        return fetchPost('/member/web/user/edit/user', toLegacyUserSaveParams(params));
    },
    // delete user
    deleteUser(params) {
        return fetchGet('/member/web/user/delete', params)
    },

    addDeviceConfirm(params) {
        return fetchPost('/device/web/device/update', params);
    },

    getAnalog(params) {
        return fetchGet('/device/web/channel/analog', params);
    },
    // disable device
    disableDevice(params) {
        return fetchPost('/device/web/device/updateStatus', params);
    },
    // device info
    deviceInfo(params) {
        return fetchGet('/device/web/channel/deviceInfo', params);
    },
    // channel header
    channelHeader(params) {
        return fetchGet('/device/web/channel/header', params);
    },
    channelHeaderV2(params) {
        return fetchGet('/device/web/channel/v2/header', params);
    },
    // channel list
    channelList(params) {
        return fetchGet('/device/web/channel/info', params);
    },
    channelListV2(params) {
        return fetchGet('/device/web/channel/v2/info', params);
    },
    // modify channel info
    modifyChannelInfo(params, id) {
        return fetchPost('/device/web/channel/modify?deviceId=' + id, params, true);
    },
    modifyChannelInfoV2(params, id) {
        return fetchPost('/device/web/channel/v2/modify?deviceId=' + id, params, true);
    },
    modifyModbusChannelInfo(params, id) {
        return fetchPost('/device/web/modbus/edit/channel?deviceId=' + id, params, true);
    },

    rebootDevice(params) {
        return fetchPost('/device/web/device/restart', params);
    },
    // upload
    upload(params) {
        return fetchPost('/member/web/user/upload', params, true, false, true, 'multipart/form-data');
    },
    save(params) {
        return fetchPost('/member/web/user/update/userInfo', params);
    },
    saveAlias(params) {
        return fetchPost('/member/web/user/change/alias', params);
    },
    createOrder(params) {
        return fetchPost('/device/web/order/create', params);
    },

    getInfoMsg(params) {
        return fetchGet('/member/web/user/get/UserInfo', params);
    },
    //SMS
    sms_balance(params) {
        return fetchGet('/device/web/order/findLeftSms', params);
    },
    sms_config(params) {
        return fetchGet('/push/web/sms/package/findSmsConfig', params);
    },
    smsUsedList(params) {
        return fetchGet('/device/web/order/smsUsedList', params);
    },
    smsOrderList(params) {
        return fetchGet('/device/web/order/list', params);
    },
    PlaceAnOrder(params) {
        return fetchPost('/device/web/order/createSms', params);
    },
    setUserPassword(params) {
        return fetchPost('/member/web/user/forgot/password', params);
    },
    getDashboardList(params) {
        return fetchGet('/device/web/dashboard/list', params);
    },
    getDashboardListAll(params) {
        return fetchGet('/device/web/dashboard/unit/all/page', params);
    },
    getAlarmLogList(params) {
        return fetchGet('/alarm/web/alarm/log/list', params);
    },
    getAlarmLogDetail(params) {
        return fetchGet('/alarm/web/alarm/log/detail', params);
    },
    getAlarmLogListPc(params) {
        return fetchGet('/alarm/web/alarm/log/lists', params);
    },
    getAlarmLogListPcV2(params) {
        return fetchGet('/alarm/web/alarm/v2/log/lists', params);
    },
    acceptAllAlarmV2(params) {
        // alarm/web/alarm/v2/accept/all
        return fetchPost('/alarm/web/alarm/v2/accept/all', params, true);
    },
    getDeviceList(params) {
        return fetchGet('/device/web/device/list', params);
    },
    getUserAlertList(params) {
        return fetchGet('/alarm/web/alarm/list', params);
    },
    getDownloadList(params) {
        return fetchGet('/device/web/download/list', params);
    },
    getUserList(params) {
        return fetchGet('/member/web/user/list', params);
    },
    deptTree(params) {
        return fetchGet('/member/web/dept/tree', params);
    },
    postTree(params) {
        return fetchGet('/member/web/post/tree', params);
    },
    deptList(params) {
        return fetchGet('/member/web/dept/list', params);
    },
    addDept(params) {
        return fetchPost('/member/web/dept/add', params, true);
    },
    updateDept(params) {
        return fetchPost('/member/web/dept/update', params, true);
    },
    deleteDept(params) {
        return fetchGet('/member/web/dept/delete', params);
    },
    postList(params) {
        return fetchGet('/member/web/post/list', params);
    },
    addPost(params) {
        return fetchPost('/member/web/post/add', params, true);
    },
    updatePost(params) {
        return fetchPost('/member/web/post/update', params, true);
    },
    deletePost(params) {
        return fetchGet('/member/web/post/delete', params);
    },
    getDeptTree(params) {
        return fetchGet('/member/web/dept/tree', params);
    },
    getPostTree(params) {
        return fetchGet('/member/web/post/tree', params);
    },
    getUserFilterRoterList() {
        return fetchGet("/member/web/role/roles", {});
    },
    getChannelList(params) {
        return fetchGet('/device/web/channel/v2/list', params);
    },
    getChannelListV1(params) {
        return fetchGet('/device/web/channel/list', params);
    },
    detailLogList(params) {
        return fetchGet('/device/web/device/detail/log/info', params);
    },
    detailLogListV2(params) {
        return fetchGet('/device/web/device/v2/detail/log/info', params);
    },
    bindAccount(params) {
        return fetchPost('/member/web/user/bind/mobile/or/email', params);
    },
    packageList(params) {
        return fetchGet('/device/web/package/list', params);
    },
    getMenus(params) {
        return fetchGet('/member/web/menu/v2/getRouters', params)
    },
    checkEmail(params) {
        return fetchPost('/member/web/user/checkEmail', params);
    },
    checkMobile(params) {
        return fetchPost('/member/web/user/checkMobile', params);
    },
    alarmDetailLogs(params) {
        return fetchGet('/alarm/web/alarm/log/detail/list', params);
    },
    getConfigKey(params) {
        return fetchGet('/system/web/config/key', params);
    },
    getNotificationList(params) {
        return fetchGet('/alarm/web/notification/log/list', params);
    },
    getDashboardAlarmList(params) {
        return fetchGet('/device/web/dashboard/alarm/unit/page', params);
    },
    getModbusAll(params) {
        return fetchGet('/device/web/modbus/all', params);
    },
    getModbusConfig(params) {
        return fetchGet('/device/web/modbus/search-config', params);
    },
    getParentDevices(params) {
        return fetchGet('/device/web/device/getDevices', params);
    },
    postParentDevices(params) {
        return fetchPost('/device/web/modbus/add', params);
    },
    postModbusConfig(params) {
        return fetchPost('/device/web/modbus/config', params, true);
    },
    postAddModbusChannel(params) {
        return fetchPost('/device/web/modbus/add/channel', params, true);
    },
    postDelModbusChannel(params) {
        return fetchPost('/device/web/modbus/del/channel', params);
    },
    getDeviceChannelInfo(params) {
        return fetchGet('/device/web/channel/deviceChannelInfo', params);
    },
    getDeviceChannelInfoV2(params) {
        return fetchGet('/device/web/channel/v2/deviceChannelInfo', params);
    },
    getDeviceChannelConfig(params) {
        return fetchGet('/device/web/channel/config', params);
    },
    getDevicePackList(params) {
        return fetchGet('/device/pack/log/web/list', params);
    },
    getLfhomeExhaustNum(params) {
        return fetchGet('/device/web/lfhome/exhaustNum', params);
    },
    getLfhomeList(params) {
        return fetchGet('/device/web/lfhome/list', params);
    },
    getLfhomeDeviceList(params) {
        return fetchGet('/device/web/lfhome/device/list', params);
    },
    postUserDisable(params) {
        return fetchPost("/member/web/account/disable", params);
    },
    roleList(params) {
        return fetchGet("/member/web/role/list", params);
    },
    addRole(params) {
        return fetchPost("/member/web/role/add", params, true);
    },
    uploadRole(params) {
        return fetchPost("/member/web/role/edit", params, true);
    },
    removeRole(params) {
        return fetchPost(`/member/web/role/remove`, params);
    },
    roleMenuList(params) {
        return fetchGet(`/member/web/menu/role/menu/list`, params);
    },
    roleInfo(params) {
        return fetchGet(`/member/web/role/info`, params);
    },
    loginOut(params) {
        return fetchGet("/system/web/config/tenant/key", params);
    },
    pushConfig(params) {
        return fetchGet("/push/web/push/get/config", params);
    },
    pushConfigSettings(params) {
        return fetchGet("/member/web/account/get/push/settings", params);
    },
    editPushConfig(params) {
        return fetchPost("/push/web/push/edit/config", params);
    },
    editPushConfigSettings(params) {
        return fetchPost("/member/web/account/update/push/settings", params, true);
    },
    pMachineFindStatistics(params) {
        return fetchGet("/device/web/machine/findStatistics", params);
    },
    pSensorAlarm(params) {
        return fetchGet("/alarm/web/alarm/get/sensor/alarm", params);
    },
    pGroupAlarm(params) {
        return fetchGet("/alarm/web/alarm/get/group/alarm", params);
    },
    pAlarmStatistics(params) {
        return fetchGet("/alarm/web/alarm/get/alarm/statistics", params);
    },
    pAlarmPendingCount(params) {
        return fetchGet("/alarm/web/alarm/pending/count", params);
    },
    pMachinePage(params) {
        return fetchGet("/device/web/machine/page", params);
    },
    pSensorTypeList(params) {
        return fetchGet("/device/web/machine/other/sensorType/list", params);
    },
    pMachineModelList(params) {
        return fetchGet("/device/app/machine/other/modbus/list", params);
    },
    pAddSensor(params) {
        return fetchPost("/device/web/modbus/v2/add", params, true);
    },
    editAddSensor(params) {
        return fetchPost("/device/web/modbus/v2/edit", params, true);
    },
    sensorInfo(params) {
        return fetchGet("/device/web/modbus/info", params);
    },
    sensorDetail(params) {
        return fetchGet("/device/web/modbus/detail", params);
    },
    addArea(params) {
        return fetchPost("/device/app/machine/area/add", params);
    },
    removeArea(params) {
        return fetchPost("/device/app/machine/area/delete", params);
    },
    editArea(params) {
        return fetchPost("/device/app/machine/area/edit", params);
    },
    areaList(params) {
        return fetchGet("/device/web/machine/area/list", params);
    },
    machineList(params) {
        return fetchGet("/device/web/machine/v3/list", params);
    },
    deleteMachine(params) {
        return fetchPost("/device/web/machine/delete", params);
    },
    machineTypeList(params) {
        return fetchGet("/device/web/machine/other/type/list", params);
    },
    addMachine(params) {
        return fetchPost("/device/web/machine/add", params, true);
    },
    editMachine(params) {
        return fetchPost("/device/web/machine/edit", params, true);
    },
    provinceList(params) {
        return fetchGet("/device/web/area/list", params, true);
    },
    machineLevelList(params) {
        return fetchGet("/device/web/machine/other/level/list", params);
    },
    isoStandardList(params) {
        return fetchGet("/device/web/machine/other/isoStandard/list", params);
    },
    machineInfo(params) {
        return fetchGet("/device/web/machine/info", params);
    },
    machineDetail(params) {
        return fetchGet("/device/web/machine/machineInfo", params);
    },
    machineUnbind(params) {
        return fetchPost("/device/web/machine/unbind", params, true);
    },
    sensorAlarm(params) {
        return fetchGet("/device/web/device/v4/detail/log/dataXY", params);
    },
    sensorAlarmV3(params) {
        return fetchGet("/device/web/device/v3/detail/log/data", params);
    },
    isoTypeList(params) {
        return fetchGet("/device/web/machine/other/isoType/list", params);
    },
    getAndSensor(params) {
        return fetchGet("/device/web/machine/getAndSensor", params);
    },
    getGroupTimeList(params) {
        return fetchGet("/device/web/device/get/group/time", params);
    },
    getGroupData(params) {
        return fetchGet("/device/web/device/get/group/data", params);
    },
    trainStart(params) {
        return fetchPost("/device/web/train/start", params);
    },
    getMachineState(params) {
        return fetchGet("/device/web/machine/get/machineState", params);
    },
    checkTrain(params) {
        return fetchPost("/device/web/train/check", params);
    },
    reasonList(params) {
        return fetchGet("/device/web/reason/list", params);
    },
    machineScore(params) {
        return fetchGet("/device/web/machine/get/machineScore", params);
    },
    inspectList(params) {
        return fetchGet("/device/web/inspect/list", params);
    },
    inspectDetail(params) {
        return fetchGet("/device/web/inspect/info", params);
    },
    addInspectInfo(params) {
        return fetchPost("/device/web/inspect/add", params, true)
    },
    editInspectInfo(params) {
        return fetchPost("/device/web/inspect/edit", params, true)
    },
    removeInspectInfo(params) {
        return fetchPost('/device/web/inspect/remove', params);
    },
    getDetectList(params) {
        return fetchGet("/device/web/detect/list", params);
    },
    addDetectInfo(params) {
        return fetchPost("/device/web/detect/add", params, true)
    },
    getDetectInfo(params) {
        return fetchGet("/device/web/detect/info", params)
    },
    editDetectInfo(params) {
        return fetchPost("/device/web/detect/edit", params, true)
    },
    removeDetectInfo(params) {
        return fetchPost("/device/web/detect/remove", params)
    },
    addMaintenanceInfo(params) {
        return fetchPost("/device/web/maintenance/add", params, true)
    },
    editMaintenanceInfo(params) {
        return fetchPost("/device/web/maintenance/edit", params, true)
    },
    getMaintenanceList(params) {
        return fetchGet("/device/web/maintenance/list", params)
    },
    removeMainTenanceInfo(params) {
        return fetchPost("/device/web/maintenance/remove", params)
    },
    getMaintenanceInfo(params) {
        return fetchGet("/device/web/maintenance/info", params)
    },
    addRepairsInfo(params) {
        return fetchPost("/device/web/repairs/add", params, true)
    },
    editRepairesInfo(params) {
        return fetchPost("/device/web/repairs/edit", params, true)
    },
    getRepairesList(params) {
        return fetchGet('/device/web/repairs/list', params)
    },
    getRepairesInfo(params) {
        return fetchGet("/device/web/repairs/info", params)
    },
    removeRepairesInfo(params) {
        return fetchPost("/device/web/repairs/remove", params);
    },
    addDeviceStatusRecord(params) {
        return fetchPost("/device/web/open/record/add", params, true);
    },
    editDeviceStatusRecord(params) {
        return fetchPost("/device/web/open/record/edit", params, true)
    },
    getDeviceStatusRecordList(params) {
        return fetchGet("/device/web/open/record/list", params);
    },
    removeDeviceStatusRecord(params) {
        return fetchPost("/device/web/open/record/remove", params);
    },
    getDeviceStatusRecordInfo(params) {
        return fetchGet("/device/web/open/record/info", params);
    },
    getOverviewFault(params) {
        return fetchGet("/alarm/web/alarm/get/fault/num", params);
    },
    getOverviewRanking(params) {
        return fetchGet("/alarm/web/alarm/get/machine/ranking", params);
    },
    getOverviewDeactivate(params) {
        return fetchGet("/device/web/machine/overview/get/deactivate", params);
    },
    getReportList(params) {
        return fetchGet("/device/report/list", params);
    },
    removeReport(params) {
        return fetchPost("/device/report/remove", params);
    },
    overviewAll(params) {
        return fetchGet("/device/web/machine/overview/get/all", params);
    },
    machinePendingAlarm(params) {
        return fetchGet("/alarm/web/alarm/get/machine/alarm/list", params);
    },
    machineGroupAlarm(params) {
        return fetchGet("/alarm/web/alarm/get/group/alarm/machine", params);
    },
    inspectTemplate(filename) {
        return downloadFile("/device/web/inspect/get-import-template", filename);
    },
    detectTemplate(filename) {
        return downloadFile("/device/web/detect/get-import-template", filename,);
    },
    repairsTemplate(filename) {
        return downloadFile("/device/web/repairs/get-import-template", filename);
    },
    maintenanceTemplate(filename) {
        return downloadFile("/device/web/maintenance/get-import-template", filename);
    },
    maintenanceImport(params) {
        return fetchPost("/device/web/maintenance/import/record", params, true, false, false, 'multipart/form-data');
    },
    inspectImport(params) {
        return fetchPost("/device/web/inspect/import/record", params, true, false, false, 'multipart/form-data');
    },
    detectImport(params) {
        return fetchPost("/device/web/detect/import/record", params, true, false, false, 'multipart/form-data');
    },
    repairsImport(params) {
        return fetchPost("/device/web/repairs/import/record", params, true, false, false, 'multipart/form-data');
    },
    deviceExportCsv(filename, params, type) {
        return downloadFile("/device/web/machine/spectrum/export-csv", filename, params, type);
    },
    dataAnnotation(params) {
        return fetchPost("/device/web/machine/data/dataAnnotation", params, true);
    },
    batchTrain(params) {
        return fetchPost("/device/web/train/start/machineIds", params, true);
    },
    featureList(params) {
        return fetchGet("/device/web/machine/feature/list", params);
    },
    deviceFindGroupTime(params) {
        return fetchGet("/device/web/device/findGroupTime", params);
    },
    manualTraining(params) {
        return fetchPost("/device/web/machine/manual/training", params);
    },
    deviceFindMachineList(params) {
        return fetchGet("/device/web/machine/find/machineList", params);
    },
    addMachineGroup(params) {
        return fetchPost("/device/web/machineGroup/add", params, true);
    },
    editMachineGroup(params) {
        return fetchPost("/device/web/machineGroup/edit", params, true);
    },
    machineGroupInfo(params) {
        return fetchGet("/device/web/machineGroup/info", params);
    },
    removeMachineGroup(params) {
        return fetchPost("/device/web/machineGroup/remove", params);
    },
    machineGroupList(params) {
        return fetchGet("/device/web/machineGroup/list", params);
    },
    sensorOfflineList(params) {
        return fetchGet("/device/web/device/get/offline/sensor/list", params);
    },
    machineHealthList(params) {
        return fetchGet("/device/web/machine/no/health/list", params);
    },
    //指标数据新
    machineIndicatorDataV2(params) {
        return fetchGet("/device/web/dt/indicator/data/v2/list", params);
    },
    //频谱数据
    machineSpectrumData(params) {
        return fetchGet("/device/web/dt/spectrum-data", params);
    },
    //获取图形数据坐标轴时间
    getRraphicList(params) {
        return fetchGet("/device/web/dt/graphic/time/list", params);
    },
    //获取图谱时间列表
    getRraphicValueList(params) {
        return fetchGet("/device/web/dt/wave/time/history-data", params);
    },
    //波形数据
    getWaveformList(params) {
        return fetchGet("/device/web/dt/waveform/data/list", params);
    },
    // 获取包络解调
    getTrendData(params) {
        return fetchGet("/device/web/dt/trend/data/list", params);
    },
    //倒谱图
    getCapstrumData(params) {
        return fetchGet("/device/web/dt/capstrum/data/list", params);
    },
    //原始波形数据
    getDtFilterList(params) {
        return fetchGet("/device/web/dt/wave-data", params);
    },
    getCepstrumDataV2(params) {
        return fetchGet("/device/web/dt/cepstrum-data", params);
    },
    //设备健康
    deviceHealthState(params) {
        return fetchGet("/device/web/dt/find/healthState", params);
    },
    //设备报警趋势
    deviceAlarmStatistics(params) {
        return fetchGet("/alarm/web/alarm/get/alarm/machine/statistics", params);
    },
    //设备时间稼动率
    deviceActivation(params) {
        return fetchGet("/device/web/dt/find/Activation", params);
    },
    //新增采集器
    addModbusV3(params) {
        return fetchPost("/device/web/modbus/v3/add", params, true);
    },
    //编辑采集器
    editModbusV3(params) {
        return fetchPost("/device/web/modbus/v3/edit", params, true);
    },
    //iso报警配置
    getMachineIsoRole(params) {
        return fetchGet("/device/web/machine/other/isoRole/list", params);
    },
    //设备类型统计
    getMachineCountType(params) {
        return fetchGet("/device/web/machine/other/count/machine/type", params);
    },
    //区域设备传感器树
    getMachineAreaTree(params) {
        return fetchGet("/device/web/machine/area/v2/list", params);
    },
    //获取设备概况列表
    getOverviewMachineList(params) {
        return fetchGet("/device/web/machine/overview/list", params);
    },
    //获取设备概况传感器详情
    getOverViewInfo(params) {
        return fetchGet("/device/web/dt/overViewInfo", params);
    },
    getNodes(params) {
        return fetchGet("/device/web/dt/nodes/by-sensor", params);
    },
    //指标趋势
    getNodeTimeSeries(params) {
        return fetchGet("/device/web/dt/node/time-series", params);
    },
    //多趋势数据
    getTimeDomainTrends(params) {
        return fetchGet("/device/web/dt/node/time-domain-trends", params);
    },
    //包络解调-频谱
    getSpectrumData(params) {
        return fetchGet("/device/web/dt/spectrum-data", params);
    },
    getQuickDtWebData(params) {
        return fetchGet("/device/web/dt/quick-query/data", params);
    },
    getOrderAnalysisData(params) {
        return fetchGet("/device/web/dt/node/order-envelope-data", params);
    },
    getCrossPhaseData(params) {
        return fetchGet("/device/web/dt/node/cross-phase-data", params);
    },
    getDTEnvelopeData(params) {
        return fetchGet("/device/web/dt/envelope-data", params);
    },
    getDTAllAlarmsData(params) {
        return fetchGet("/device/web/alarm/limit/node", params);
    },
    saveDTAlarmBatchLimit(data) {
        return fetchPost("/device/web/alarm/limit/batch", data, true);
    },
    getCaptureList(params) {
        return fetchGet("/device/web/collection/list", params);
    },
    getCaptureTemplatesList(params) {
        return fetchGet("/device/web/collection/templates", params);
    },
    addDeviceCollectionForm(data) {
        return fetchPost("/device/web/collection/add", data, true);
    },
    getDeviceCollectionDetail(params) {
        return fetchGet("/device/web/collection/info", params);
    },
    updateDeviceCollectionForm(data) {
        return fetchPost("/device/web/collection/update", data, true);
    },
    deletedDeviceCollection(data) {
        return fetchPost("/device/web/collection/delete", data);
    },
    deleteDeviceIOT(data) {
        return fetchPost("/device/app/device/delete", data);
    },
    getMachineShutdown(params) {
        return fetchGet("/device/web/machine/runtime/statistics/page", params);
    },
    editFrontRunTime(data) {
        return fetchPost("/device/web/machine/runtime/statistics/editFrontRunTime", data, true);
    },
    getMachineShutdownInfo(params) {
        return fetchGet("/device/web/machine/shutdown/info", params);
    },
    addShutdownMachine(data) {
        return fetchPost("/device/web/machine/shutdown/add", data, true);
    },
    baseNodeConfig(data) {
        return fetchPost("/device/web/base-node/config", data, true);
    },
    getMachineRuntime(params) {
        return fetchGet("/device/web/machine/runtime/statistics/find/runState", params);
    },
    getMachinePcaHealthScore(params) {
        return fetchGet("/device/web/machine/pca/health/score", params);
    },
    getMachineTypeList(params) {
        return fetchGet("/device/web/machine/type/list", params);
    },
    getMachineTypeAll(params) {
        return fetchGet("/device/web/machine/type/all", params);
    },
    getDeviceParameterList(params) {
        return fetchGet("/device/web/component/parameter/list", params);
    },
    getDeviceComponentTree(params) {
        return fetchGet("/device/web/component/tree", params);
    },

    getComponentParameters(params) {
        return fetchGet("/device/web/component/parameters", params);
    },
    getComponentPointMetrics(params) {
        return fetchGet("/device/web/component/point/metrics", params);
    },
    putPointPositions(params) {
        return fetchPut("/device/web/machine/type/point/positions", params, true);
    },

    // ========== 固件升级 ==========
    getFirmwareUpgradeList(params) {
        return fetchGet("/device/web/firmware-upgrade/list", params);
    },
    addFirmwareUpgrade(params) {
        return fetchPost("/device/web/firmware-upgrade/add", params, true);
    },
    deleteFirmwareUpgrade(params) {
        return fetchPost("/device/web/firmware-upgrade/delete", params);
    },
    executeFirmwareUpgrade(params) {
        return fetchPost("/device/web/firmware-upgrade/execute", params);
    },
    getFirmwareUpgradeDetail(params) {
        return fetchGet("/device/web/firmware-upgrade/detail", params);
    },
    getFirmwareCollectorTypes(params) {
        return fetchGet("/device/web/firmware-upgrade/collector-types", params);
    },
    getFirmwareCollectors(params) {
        return fetchGet("/device/web/firmware-upgrade/collectors", params);
    },
    uploadFirmwareFile(params) {
        return fetchPost("/device/web/firmware-upgrade/upload", params);
    },
};
